import React, { useEffect, useState } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { Redirect, Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";
import { baseurl } from "../../../baseurl";
import InputMask from "react-input-mask";
import axios from "axios";
import swal from "@sweetalert/with-react";
import "react-datepicker/dist/react-datepicker.css";
import { Select } from "@material-ui/core";
import { checkPermission } from "../../../Helper";

export default function EmailSetting() {
  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(2);
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/EmailSetting";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  var companyId = localStorage.getItem("companyId");
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  const [data, setData] = useState({
    emailNotify: false,
    emailSet: true,
  });
  const [emailInfo, setEmailInformation] = useState({
    emailServerProtocol: "",
    emailServerHost: "",
    emailServerPort: "",
    emailServerUsername: "",
    emailServerPassword: "",
  });
  const inputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setEmailInformation({
      ...emailInfo,
      [name]: value,
    });
  };

  const handleSubmitForms = (event) => {
    event.preventDefault();
    var companyId = localStorage.getItem("companyId");
    var masterId = localStorage.getItem("masterId");

    axios
      .post(
        `${baseurl}/masterData/getAddEmailPreferrences`,
        {
          serverProtocol: emailInfo.emailServerProtocol,
          serverHost: emailInfo.emailServerHost,
          serverPort: emailInfo.emailServerPort,
          serverUsername: emailInfo.emailServerUsername,
          serverPassword: emailInfo.emailServerPassword,
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        swal({
          title: "Saved Successfully!",
          text: "Email Preferrences is Added",
          icon: "success",
        }).then((value) => {
          if (data.addClientP) {
            //  window.location.reload()
            //refreshForm();
          } else {
            //toggleAddNew();
          }
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const emailNotification = () => {
    setData({ ...data, emailNotify: true, emailSet: false });
  };
  const emailSetting = () => {
    setData({ ...data, emailSet: true, emailNotify: false });
  };

  const arr = [
    {
      id: 1,
      lable: "Email Setting",
      click: emailSetting,
    },
    {
      id: 2,
      lable: "  Email Notification",
      click: emailNotification,
    },
  ];
  return (
    <>
      <div className="rowStyling mt-1">
        <div className="row mb-2 pt-2">
          <div className="col-md-8 ">
            <strong>
              <h1 className="px-4 ">Email Settings</h1>
            </strong>
          </div>

          <div className="col-md-4">
            {arr.map((arr) => (
              <button className="button-13 mx-1" onClick={arr.click}>
                {arr.lable}
              </button>
            ))}

            {/* <button className="button-13 mx-2" onClick={emailNotification}>
              Email Notification
            </button> */}
          </div>
        </div>
        <div className="row"></div>
        <hr
          style={{
            borderTop: "1px solid rgb(221, 221, 221)",
            width: "90%",
            position: "relative",
          }}
        />
        {data.emailNotify === true && (
          <>
            <div className=" col-md-12 ">
              <strong>
                <h3>Email Notifications Settings</h3>
              </strong>
              <p className="px-3 py-2">
                Here you can select who is notified when certain events occur.
                Just select the person you want notified from the dropdown, or
                select 'No Notification Sent'.
              </p>
            </div>
            <div className="rowStyling">
              <div className="row">
                <div className="col-md-12">
                  <Form
                    // onSubmit={handleSubmitForms}
                    name="addNewForm"
                  >
                    <div className="row m-4">
                      <div className="col-md-8 ">
                        <Label>
                          Who should receive read receipt emails for your
                          invoices?
                        </Label>
                        <Select type="" className="form-control" />
                      </div>

                      <div className="col-md-8 ">
                        <Label>
                          Who should receive notifications from about new
                          features?
                        </Label>
                        <Select type="text" className="form-control" />
                      </div>
                      <div className="col-md-12 ">
                        <hr
                          style={{
                            borderTop: "1px solid rgb(221, 221, 221)",
                            width: "90%",
                            position: "relative",
                            // left: "-15px",
                          }}
                        />
                      </div>

                      <div className="col-md-12 mt-2">
                        <strong>
                          <h3>Billing Notifications Settings</h3>
                        </strong>
                      </div>
                      <div className="col-md-8 ">
                        <Label>
                          Who should receive invoices from for our premium
                          features?
                        </Label>
                        <Select type="Password" className="form-control" />
                      </div>
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        marginBottom: "3vh",
                        marginTop: "3vh",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <FormGroup style={{ textAlign: "center" }}>
                      <div className="row m-3  Submit-Invoice-btn-div">
                        <Button
                          type="submit"
                          className="mr-1 invoiceSubmitButton"
                        >
                          Save
                        </Button>
                      </div>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </div>
          </>
        )}
        {data.emailSet === true && (
          <div>
            <div className=" col-md-12 mx-2">
              <strong>
                <h3>Email Server Settings</h3>
              </strong>
              <p className="px-3 py-2">
                By default, any invoices / payslips that you email from are
                emailed from the email server with your name and email address.
                This is fine for most people, but if you would rather the emails
                to come from your own servers then you can specify the details
                below
              </p>
            </div>
            <div className="rowStyling">
              <div className="row">
                <div className="col-md-12">
                  <Form onSubmit={handleSubmitForms} name="addNewForm">
                    <div className="row m-4">
                      <div className="col-md-8 ">
                        <Label>
                          Email Server protocol:
                          <h8 style={{ color: "gray", marginLeft: "150px" }}>
                            eg. smtp.gmail.com
                          </h8>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="emailServerProtocol"
                          id="emailServerProtocol"
                          onChange={inputEvent}
                          required
                          value={emailInfo.emailServerProtocol}
                        />
                      </div>
                      <div className="col-md-8 ">
                        <Label>
                          Email Server host:
                          <h8 style={{ color: "gray", marginLeft: "250px" }}>
                            the name of your email server,
                          </h8>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="emailServerHost"
                          id="emailServerHost"
                          onChange={inputEvent}
                          required
                          value={emailInfo.emailServerHost}
                        />
                      </div>
                      <div className="col-md-8 ">
                        <Label>
                          Email Server port:
                          <h8 style={{ color: "gray", marginLeft: "350px" }}>
                            eg. 465
                          </h8>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="emailServerPort"
                          id="emailServerPort"
                          onChange={inputEvent}
                          required
                          value={emailInfo.emailServerPort}
                        />
                      </div>
                      <div className="col-md-8 ">
                        <Label>
                          Email Server Username:
                          <h8 style={{ color: "gray", marginLeft: "40px" }}>
                            the user to login to the server as, eg.
                            me@mydomain.com
                          </h8>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="emailServerUsername"
                          id="emailServerUsername"
                          onChange={inputEvent}
                          required
                          value={emailInfo.emailServerUsername}
                        />
                      </div>
                      <div className="col-md-8 ">
                        <Label>
                          Email Server Password:
                          <h8 style={{ color: "gray", marginLeft: "50px" }}>
                            the password of the user to login to the server as
                          </h8>
                        </Label>
                        <Input
                          type="password"
                          className="form-control"
                          name="emailServerPassword"
                          id="emailServerPassword"
                          onChange={inputEvent}
                          required
                          value={emailInfo.emailServerPassword}
                        />
                      </div>
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        marginBottom: "3vh",
                        marginTop: "3vh",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <FormGroup style={{ textAlign: "center" }}>
                      <div className="row m-3  Submit-Invoice-btn-div">
                        <Button
                          type="submit"
                          // color="success"
                          className="mr-1 invoiceSubmitButton"
                          // size="sm"
                        >
                          save
                        </Button>
                      </div>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
